import { Component, Input, OnInit } from "@angular/core"
import { MuxDataModel } from "../../../models/muxData.model"
import { Resource } from "../../../models/resource/resource"
import { ResourceService } from "../../../services/resource.service"
import { WindowSizeService } from "../../../services/window-size.service"
import { GtmVideoJsInfo } from "../../../utils/types"
import { UserService } from "../../../services/user.service"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { CautionFlagsService } from "../../../services/caution-flags.service"
import { takeUntil, tap } from "rxjs/operators"
import { Observable, Subject } from "rxjs"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-video-resource",
    templateUrl: "./video-resource.component.html",
    styleUrls: ["./video-resource.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class VideoResourceComponent implements OnInit {
    @Input() resource: Resource
    muxData: MuxDataModel
    gtmVideoJsInfo: GtmVideoJsInfo
    isAddonView: boolean
    isCautionFlagContainerDisplayed: boolean
    private destroyed$: Subject<void> = new Subject<void>()

    cautionFlagDisplayObservable: Observable<boolean> =
        this.cautionFlagsService.cautionFlagDisplayObservable.pipe(
            tap((nextState: boolean) => (this.isCautionFlagContainerDisplayed = nextState)),
            takeUntil(this.destroyed$)
        )

    constructor(
        public windowSize: WindowSizeService,
        public resourceService: ResourceService,
        public userService: UserService,
        private addOnService: AddOnViewService,
        private cautionFlagsService: CautionFlagsService
    ) {}

    ngOnInit() {
        this.cautionFlagDisplayObservable.subscribe()
        this.isAddonView = this.addOnService.isAddonView
        this.gtmVideoJsInfo = {
            title: this.resource.selectedAsset.title,
            guid: this.resource.selectedAsset.guid,
            type: this.resource.selectedAsset.mediaType,
        }

        if (this.resource.selectedAsset && this.resource.selectedAsset.selectedMedia) {
            this.muxData = this.resource.getMuxData()
        }
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
